/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useCallback } from 'react';
import styled from 'styled-components';
import { space, color } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import Close from 'theme/icons/close';
import Text from 'theme/text';

const Wrapper = styled.div`
  ${space}

  display: flex;
  flex-direction: row;
  width: fit-content;
  height: 38px;
  border: 2px solid ${themeGet('colors.primary_100')};
  border-radius: 4px;
  background-color: ${themeGet('colors.white')};
  align-items: center;

  & > .tag-label {
    ${color}

    width: 8px;
    height: 100%;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  & > .tag-body {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 0 0 ${themeGet('space.s')}px;
    flex: 1;
  }

  & > .tag-close {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 38px;
    height: 100%;
  }
`;

const NotButton = styled.span`
  color: ${themeGet('colors.red_400')};
  font-weight: bold;
  font-size: 9px;
  text-transform: uppercase;
  padding: 2px 6px;
  border-radius: 3px;
  cursor: pointer;
  user-select: none;
  background-color: ${themeGet('colors.red_50')};
  border: 1px solid ${themeGet('colors.red_200')};
  line-height: 1;
  margin-left: ${themeGet('space.xs')}px;
  
  &:hover {
    background-color: ${themeGet('colors.red_100')};
    border-color: ${themeGet('colors.red_300')};
  }
`;

function Tag({ tagId, labelColor, labelTitle, value, onDelete, isExclusive = false, onToggleExclusive }) {
  const handleDelete = useCallback(() => {
    onDelete(tagId);
  }, [tagId, onDelete]);

  const handleToggleExclusive = useCallback(() => {
    if (onToggleExclusive) {
      onToggleExclusive(tagId);
    }
  }, [tagId, onToggleExclusive]);

  return (
    <Wrapper mr="xs" mb="xs" bg={labelColor}>
      <div className="tag-label" />
      <div className="tag-body">
        <Text fontSize="display" lineHeight="display" fontWeight="bold" color="grey_600" mr="xxs">
          {`${isExclusive ? 'NOT ' : ''}${labelTitle}: `}
        </Text>
        <Text fontSize="h3" lineHeight="h3" fontWeight="normal" color="grey_400">
          {value}
        </Text>
        {!isExclusive && onToggleExclusive && (
          <NotButton onClick={handleToggleExclusive}>
            NOT
          </NotButton>
        )}
      </div>
      <div className="tag-close" onClick={handleDelete}>
        <Close />
      </div>
    </Wrapper>
  );
}

export default Tag;
